import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";

export const DefaultCashflowDrillDownTransactionView: NamedView<TransactionView> =
    {
        id: "default",
        name: "Default",
        type: ViewType.TRANSACTION,
        options: {
            bulkActions: true,
            selection: true,
        },
        filters: {},
        columns: [
            {
                id: TransactionColumn.DATE,
                options: {
                    pin: "left",
                },
            },
            {
                id: TransactionColumn.SPLIT,
                options: {
                    pin: "left",
                },
            },
            {
                id: TransactionColumn.DESCRIPTION,
            },
            {
                id: TransactionColumn.BANK_DESCRIPTION,
            },
            {
                id: TransactionColumn.CATEGORY,
            },
            {
                id: TransactionColumn.COUNTERPARTY,
            },
            {
                id: TransactionColumn.AMOUNT,
                options: {
                    pin: "right",
                },
            },
            {
                id: TransactionColumn.ENTITY,
                options: {
                    pin: "right",
                },
            },
        ],
    };
